<section-anchor [valid]="valid" [touched]="touched"></section-anchor>
<div class="header-content" [class.compact]="compact">
  <div class="v2-h5">
    <ng-content></ng-content>
    @if (optional) {
      <span class="optional">
        {{ optionalText || '(optional)' }}
      </span>
    }
  </div>
  @if (tooltipText) {
    <info-tooltip
      matSuffix
      [text]="tooltipText"
    ></info-tooltip>
  }
</div>
